if (!window.__cartTermsGuardInitialized) {
  window.__cartTermsGuardInitialized = true;

  // cart-subtotal.liquid renders twice on the cart page (page + hidden cart
  // drawer), so this script tag appears twice. The guard above (a property
  // on window, not a block-scoped identifier) ensures everything below runs
  // exactly once regardless of how many times the tag is parsed.

  // Duplicate #AgreeToTos checkboxes can exist for the same reason. Only the
  // visible one(s) should gate checkout; a hidden, never-checked duplicate
  // must not block forever.
  function isDeliveryAgreementChecked() {
    var checkboxes = document.querySelectorAll('#AgreeToTos');
    if (!checkboxes.length) return true;
    var visible = Array.prototype.filter.call(checkboxes, function (cb) {
      return cb.offsetParent !== null;
    });
    var relevant = visible.length ? visible : checkboxes;
    return Array.prototype.every.call(relevant, function (cb) {
      return cb.checked;
    });
  }

  function highlightDeliveryAgreement() {
    var checkboxes = document.querySelectorAll('#AgreeToTos');
    Array.prototype.forEach.call(checkboxes, function (cb) {
      if (cb.offsetParent === null) return;
      cb.focus();
      cb.style.outline = '2px solid #d0021b';
      cb.style.outlineOffset = '2px';
      window.setTimeout(function () {
        cb.style.outline = '';
        cb.style.outlineOffset = '';
      }, 1500);
    });
  }

  // Primary guard: disable the native elements directly. A disabled
  // <button> never dispatches a click event at all, which sidesteps any
  // race with third-party scripts that attach their own listeners
  // (window-level, capturing, delegated, etc.) — those listeners simply
  // never fire, regardless of load order. This covers #CheckOut and any
  // app-injected button marked with data-captain-button (Captain shipping
  // protection renders its "Protected checkout" button this way; new
  // buttons it injects asynchronously are caught by the MutationObserver
  // below).
  function guardedButtons() {
    var nodes = document.querySelectorAll('#CheckOut, [data-captain-button], #captain-checkout');
    return Array.prototype.filter.call(nodes, function (el) {
      return 'disabled' in el;
    });
  }

  function applyCheckoutGate() {
    var allowed = isDeliveryAgreementChecked();
    guardedButtons().forEach(function (el) {
      el.disabled = !allowed;
      el.style.opacity = allowed ? '' : '0.5';
      el.style.cursor = allowed ? '' : 'not-allowed';
    });
  }

  var observer = new MutationObserver(applyCheckoutGate);
  observer.observe(document.body, { childList: true, subtree: true });

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('#AgreeToTos');
      if (!this.checkbox) return;

      applyCheckoutGate();

      this.checkbox.addEventListener('change', applyCheckoutGate);
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

  // Fallback layer: elements that can't be natively disabled (e.g. plain
  // <a href> links, like Captain's "Checkout without protection") are
  // guarded by intercepting checkout-looking clicks/submits anywhere on the
  // page while the delivery agreement is unchecked.
  document.addEventListener('click', function (event) {
    if (isDeliveryAgreementChecked()) return;
    var target = event.target.closest && event.target.closest('button, a[href]');
    if (!target || target.id === 'CheckOut' || target.disabled) return;
    var href = target.getAttribute('href');
    var text = (target.textContent || '').trim().toLowerCase();
    if ((href && /\/checkout/i.test(href)) || text.includes('checkout')) {
      event.preventDefault();
      event.stopPropagation();
      highlightDeliveryAgreement();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (isDeliveryAgreementChecked()) return;
    var form = event.target;
    if (form && (form.id === 'cart' || /checkout/i.test(form.getAttribute('action') || ''))) {
      event.preventDefault();
      highlightDeliveryAgreement();
    }
  }, true);

  // Fallback layer: guard Captain's global captainSubmitCheckout(el, event,
  // withProtection) function directly, in case some future Captain button
  // isn't natively disable-able or isn't caught by the click interceptor.
  // Wrap it only after window 'load' (i.e. after Captain's own deferred
  // script has already defined it), so Captain's script can't overwrite
  // our wrapper when it finishes loading.
  window.addEventListener('load', function () {
    if (typeof window.captainSubmitCheckout !== 'function') return;
    var real = window.captainSubmitCheckout;

    window.captainSubmitCheckout = function (el, event, withProtection) {
      if (!isDeliveryAgreementChecked()) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        highlightDeliveryAgreement();
        return false;
      }
      return real.apply(this, arguments);
    };
  });
}
